import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import TaskItem from './TaskItem';
import weekApprovalUiActions from "../actions/weekApprovalUiActionCreators";

class ProjectItem extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    countHours = (task, status) => {
        let sum = 0;
        task.approvedHours.map( (approvedHour) => {
            if(approvedHour.status === status || (status === "ENTRY" && approvedHour.status === "FIXING"))
                sum += approvedHour.regularTime;
        });
        if (sum % 60 === 0)
            return sum / 60 + "h";
        else
            return `${Math.floor(sum / 60)}h ${sum % 60}min`;
    }

    handleClick = () => {
        this.props.handleClick(this.props.id);
    }

    handleTaskItemClick = (key) => {
      this.props.handleTaskItemClick(this.props.projectKey, key);
    }

    // RENDER METHOD

    render = () => {

        let showBadge = this.props.showBadge;

        if (showBadge && this.props.toApprove == 0) {
            showBadge = false;
        }

        if (this.props.active) {
            return (
                <div className="panel panel-default panel-pmproject" >
                    <div className="panel-heading" role="tab" id="headingThree-outer">
                        { showBadge ? <span className="label">{this.props.toApprove}</span> : null }
                        <h4 className="panel-title" style={{backgroundColor : this.props.defaultColor}}>
                        <a style={{"cursor" : "pointer"}} onClick={this.handleClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                            {this.props.projectName}
                            <span className="acc"><span className="md-expand-more"></span></span>
                            <span style={{textTransform : "none"}} className="pull-right">
                                <span title="Hours logged and not yet submitted on project" style={{fontStyle : "italic"}}> { this.props.formattedHoursEntry } </span>
                                <span title="Hours submitted on project"> { this.props.formattedHoursSubmitted && this.props.formattedHoursEntry ? "|" : ""} { this.props.formattedHoursSubmitted } </span>
                                <span title="Hours approved on project">
                                    { this.props.formattedHoursApproved && (this.props.formattedHoursEntry || this.props.formattedHoursSubmitted) ? "|" : ""} {this.props.formattedHoursApproved} &nbsp;
                                    { this.props.toApprove === 0 ? <span className="md-done" /> : null }
                                </span>
                            </span>
                        </a>
                        </h4>
                    </div>
                    <div id="collapseThree-outer" className="panel-collapse" role="tabpanel" aria-labelledby="headingThree">
                        <div className="panel-body">
                            <div className="panel-group" id="accordion-inner" role="tablist" aria-multiselectable="true">
                            {
                                this.props.tasks.map((task, taskKey) => {
                                    if (task.timeApproved === 0 && task.timeOvertime === 0 && task.timeTotal === 0) {
                                        return null;
                                    }
                                    return <TaskItem
                                               active={this.props.taskOpen === undefined ? false : this.props.taskOpen[taskKey]}
                                               color={this.props.defaultColor}
                                               date={this.props.date}
                                               formattedHoursApproved={this.countHours(task, "APPROVED")}
                                               formattedHoursEntry={this.countHours(task, "ENTRY")}
                                               formattedHoursSubmitted={this.countHours(task, "SUBMITTED")}
                                               handleApprove={this.props.handleApprove}
                                               handleClick={this.handleTaskItemClick}
                                               handleReject={this.props.handleReject}
                                               id={taskKey}
                                               key={taskKey}
                                               projectKey={this.props.projectKey}
                                               projectName={this.props.projectName}
                                               projectNames={this.props.projectNames}
                                               shouldApprove={this.props.shouldApprove}
                                               showBadge={showBadge}
                                               task={task}
                                               taskKey={taskKey}
                                               />;
                                })
                            }
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="panel panel-default panel-pmproject" >
                    <div className="panel-heading" role="tab" id="headingThree-outer">
                        { showBadge ? <span className="label">{this.props.toApprove}</span> : null }
                        <h4 className="panel-title" style={{backgroundColor : this.props.defaultColor}}>
                        <a style={{"cursor" : "pointer"}} onClick={this.handleClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                            {this.props.projectName}
                            <span className="acc"><span className="md-chevron-right"></span></span>
                            <span style={{textTransform : "none"}} className="pull-right">
                                <span title="Hours logged and not yet submitted on project" style={{fontStyle : "italic"}}> { this.props.formattedHoursEntry } </span>
                                <span title="Hours submitted on project"> { this.props.formattedHoursSubmitted && this.props.formattedHoursEntry ? "|" : ""} {this.props.formattedHoursSubmitted} </span>
                                <span title="Hours approved on project">
                                    { this.props.formattedHoursApproved && (this.props.formattedHoursEntry || this.props.formattedHoursSubmitted) ? "|" : ""} {this.props.formattedHoursApproved} &nbsp;
                                    { this.props.toApprove === 0 ? <span className="md-done" /> : null }
                                </span>
                            </span>
                        </a>
                        </h4>
                    </div>
                    <div id="collapseThree-outer" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                        <div className="panel-body">
                        </div>
                    </div>
                </div>
            );
        }
    }
}

ProjectItem.propTypes = {
    active: PropTypes.bool,
    date: PropTypes.object,
    defaultColor: PropTypes.string,
    handleApprove: PropTypes.func,
    handleClick: PropTypes.func,
    handleReject: PropTypes.func,
    handleTaskItemClick: PropTypes.func,
    list: PropTypes.array,
    formattedHoursApproved: PropTypes.string,
    formattedHoursEntry: PropTypes.string,
    formattedHoursSubmitted: PropTypes.string,
    id: PropTypes.number,
    projectKey: PropTypes.number,
    projectName: PropTypes.string,
    projectNames: PropTypes.array,
    shouldApprove: PropTypes.bool,
    showBadge: PropTypes.bool,
    taskOpen: PropTypes.array,
    tasks: PropTypes.array,
    toApprove: PropTypes.number
};

ProjectItem.defaultProps = {
    tasks: []
};

export default connect()(ProjectItem);



/** WEBPACK FOOTER **
 ** ./src/app/components/ProjectItem.js
 **/